import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getCALLSHEETTableStructure";
export const UPDATE_TABLE_DATA = "getCALLSHEETTableData";
export const EXPORT_TABLE_DATA = "exportCALLSHEETTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setCALLSHEETTableStructure";
export const SET_TABLE_DATA = "setCALLSHEETTableData";
export const SET_TABLE_FILTER = "setCALLSHEETTableFilter";
export const SET_FILTER_CHANGE = "setCALLSHEETFilterChange";
export const SET_TABLE_PAGE = "setCALLSHEETTablePage";
export const SET_TABLE_PERPAGE = "setCALLSHEETTablePerPage";
export const SET_TABLE_SORTBY = "setCALLSHEETTableSortBy";
export const SET_TABLE_SORTORDER = "setCALLSHEETTableSortOrder";
export const SET_EXPORT_LINK = "setCALLSHEETExportLink";

const state = {
  queryObject: {},
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  /**
   * for table title, descripton
   * */
  getCALLSHEETTableProperties(state) {
    return state.table_structure.properties;
  },
  /**
   * for table permissions
   **/
  getCALLSHEETTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getCALLSHEETPrintTypes(state) {
    return state.table_structure.print;
  },
  getCALLSHEETTableState(state) {
    return state.table_state;
  },
  getCALLSHEETTableHeaders(state) {
    return state.table_structure.columns;
  },

  getCALLSHEETTableFilters(state) {
    return state.table_structure.filters;
  },

  getCALLSHEETTableData(state) {
    return state.table_data.data;
  },

  getCALLSHEETExportUrl(state) {
    return state.export_link;
  },
  getCALLSHEETStatuses(state) {
    // console.log(state, state.table_structure.call_statuses[0]);
    return state.table_structure.call_statuses;
  },
  getCALLSHEETstatistics(state) {
    // console.log(state, state.table_structure.call_statuses[0]);
    return state.table_structure.statistics;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/customer_service/call_sheets")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
          setTimeout(() => {
            context.commit(SET_PAGE_LOADING, false);
          }, 500);
        })
        .catch((data) => {
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/customer_service/call_sheets/datatable", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          setTimeout(() => {
            context.commit(SET_PAGE_LOADING, false);
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/customer_service/call_sheets/export", payload)
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    // console.log("order state of filter update", filter);
    state.table_state.filters = filter;
  },

  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
